import React from 'react'

class DreamHostHeader extends React.Component {
	render() {
		return <div className="dh">
			<div className="navbar">
				<div className="navbar-inner">
					<img className="dreamhost-logo" src="/assets/dreamhost-logo.png" alt="Dreamhost"/>
					<img className="blogvault-logo" src="/assets/powered-by-blogvault-logo.png" alt="Powered by BlogVault"/>
				</div>
			</div>
		</div>
	}
}

export default DreamHostHeader
